import { GridState, GridTopology } from '../types';

/**
 * Convert a GridState to a GridTopology by dropping the dispatch results
 * (the computed values), keeping every structural/input field.
 *
 * This strips the dispatch fields by name rather than whitelisting the
 * topology fields, so any topology attribute — battery parameters, DC
 * `reactance`, and the AC power-flow `ac` overrides — survives the round trip.
 * A whitelist here silently drops newer fields: dropping `ac` left ACPF with no
 * specified injections/bus roles (falling back to nameplate capacity) and a
 * network with default reactances, so a scenario loaded through this conversion
 * could not solve in AC mode.
 */
export function gridStateToTopology(gridState: GridState): GridTopology {
  return {
    nodes: gridState.nodes.map(({ value, voltage, voltageAngle, lmp, ...topology }) => topology),
    edges: gridState.edges.map(({ current, ...topology }) => topology),
  };
}
